export * from '../src/composites/wui-icon-box/index.js';
//# sourceMappingURL=wui-icon-box.js.map